import { DateTime } from 'luxon'
import { dateSchema } from 'util/schema-date'
import type { useTranslationTyped } from 'i18n/i18n'
import { formatDateTime } from 'util/dates'

export const getRoomStateScheduledAtSchema = ({
  tt,
  expiresAt,
  skipRequired,
  availableFrom,
}: {
  tt: ReturnType<typeof useTranslationTyped>['tt']
  expiresAt: DateTime | undefined
  skipRequired?: boolean
  availableFrom?: DateTime
}) => {
  const now = DateTime.now().startOf('minute') // that allows you to use "now" when starting a meeting
  const availableFromMinute = availableFrom?.startOf('minute')
  const minDate =
    availableFromMinute && availableFromMinute > now ? availableFromMinute : now
  const minMessage =
    availableFromMinute && availableFromMinute > now
      ? tt.student_assignment.scheduled_date_before_available({
          date: formatDateTime(availableFromMinute),
        })
      : tt.student_assignment.scheduled_date_in_past()

  const schema = dateSchema({
    required:
      skipRequired === true
        ? undefined
        : tt.student_assignment.scheduled_date_required(),
    invalid: tt.student_assignment.scheduled_date_invalid(),
    min: {
      date: minDate,
      message: minMessage,
    },
    max: expiresAt
      ? {
          date: expiresAt,
          message: tt.student_assignment.scheduled_date_after_deadline({
            deadline: expiresAt.toLocaleString(DateTime.DATETIME_SHORT),
          }),
        }
      : undefined,
  })

  if (skipRequired) return schema.optional()

  return schema
}
